import script from "./StoreAdminDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./StoreAdminDashboard.vue?vue&type=script&setup=true&lang=js"

import "./StoreAdminDashboard.vue?vue&type=style&index=0&id=15773120&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15773120"]])

export default __exports__